import { useState, useEffect } from "react";
import { Wifi, WifiOff, AlertTriangle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export function ConnectionStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowStatus(true);
      // Hide success message after 3 seconds
      setTimeout(() => setShowStatus(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowStatus(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Show status immediately if offline
    if (!navigator.onLine) {
      setShowStatus(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <AnimatePresence>
      {showStatus && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium shadow-lg ${
            isOnline 
              ? "bg-green-500/90 text-white" 
              : "bg-red-500/90 text-white"
          }`}
        >
          {isOnline ? (
            <>
              <Wifi className="w-4 h-4" />
              <span>Connection restored</span>
            </>
          ) : (
            <>
              <WifiOff className="w-4 h-4" />
              <span>No internet connection</span>
            </>
          )}
        </motion.div>
      )}
      
      {/* Persistent offline indicator */}
      {!isOnline && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="fixed bottom-4 right-4 bg-red-500/90 text-white px-3 py-2 rounded-lg flex items-center gap-2 text-sm shadow-lg z-50"
        >
          <AlertTriangle className="w-4 h-4" />
          <span>Offline</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}